export class Contacto{
    Email: string;
    Telefono: string;
    Nombre: string;
    Texto: string;
}